function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.302 45.698a21.517 21.517 0 0 0 30.43-30.43L21.517 30.483 6.302 45.698z",
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.697 6.302a21.518 21.518 0 0 0-30.43 30.43l15.216-15.215L45.697 6.302zM76.661 30.122c0-1.732-.404-3.123-1.426-4.094-.807-.788-2.044-1.313-3.766-1.549l-2.313-.315c-.673-.078-1.076-.315-1.319-.55a1.215 1.215 0 0 1-.376-.867c0-.813.672-1.732 2.313-1.732.834 0 2.421-.079 3.632 1.102l2.96-2.886C74.723 17.63 72.652 17 69.908 17c-4.358 0-6.994 2.493-6.994 5.905 0 1.6.43 2.86 1.318 3.752.86.866 2.152 1.418 3.847 1.654l2.313.315c.619.078 1.022.262 1.264.498.27.289.377.656.377 1.103 0 1.075-.888 1.68-2.744 1.68-1.533 0-3.282-.342-4.277-1.313L62 33.534C63.937 35.474 66.331 36 69.263 36c4.035 0 7.398-2.073 7.398-5.878zM93.594 29.282V17.157h-4.708v12.02c0 1.732-1.022 2.73-2.583 2.73-1.56 0-2.528-.998-2.528-2.73v-12.02h-4.708v12.125c0 4.094 3.255 6.718 7.236 6.718 3.982 0 7.29-2.624 7.29-6.718zM106.205 23.167c0 .971-.753 1.89-2.044 1.89h-2.663v-3.78h2.663c1.291 0 2.044.92 2.044 1.89zm5.73 12.675l-4.143-7.794c1.507-.734 3.121-2.335 3.121-4.88 0-3.071-2.287-6.01-6.537-6.01H96.79v18.684h4.708v-6.954h1.587l3.389 6.954h5.461zM127 35.843v-4.094h-8.312v-3.28h7.101v-4.095h-7.101v-3.123H127v-4.094h-13.02v18.686H127z",
  fill: "#1F55E7"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 27.255,
  y1: 18.29,
  x2: 39.895,
  y2: 47.434,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", null), React.createElement("stop", {
  offset: 0.022,
  stopColor: "#020611"
}), React.createElement("stop", {
  offset: 0.102,
  stopColor: "#0A1B49"
}), React.createElement("stop", {
  offset: 0.183,
  stopColor: "#102D79"
}), React.createElement("stop", {
  offset: 0.263,
  stopColor: "#163BA1"
}), React.createElement("stop", {
  offset: 0.341,
  stopColor: "#1A46BF"
}), React.createElement("stop", {
  offset: 0.416,
  stopColor: "#1D4FD5"
}), React.createElement("stop", {
  offset: 0.489,
  stopColor: "#1E53E3"
}), React.createElement("stop", {
  offset: 0.555,
  stopColor: "#1F55E7"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 127,
    height: 52,
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.77d73f09.svg";
export { ForwardRef as ReactComponent };